(ns hai.home.clock
  "Current time for the home dashboard, advanced once a minute."
  (:require
   [hai.datetime :as datetime]
   [hai.ui.rf-sugar :refer [defevent defsub]]))

(defevent ::tick [db _]
  (assoc db ::now-ms (.getTime (js/Date.))))

(defevent ::clear [db _]
  (dissoc db ::now-ms))

(defsub ::now-ms [db]
  (get db ::now-ms))

(defsub ::parts [now-ms <- ::now-ms]
  (when now-ms
    (datetime/time-parts (js/Date. now-ms))))

(defsub ::date-label [now-ms <- ::now-ms]
  (when now-ms
    (datetime/format-date-label (js/Date. now-ms))))

(defsub ::date-label-short [now-ms <- ::now-ms]
  (when now-ms
    (datetime/format-date-label-short (js/Date. now-ms))))
